// ハンバーガー
$(function(){
    $('#hamburger-btn').on('click', function() {
        $('.js-hamburger').toggleClass('js-active');
    });
});

$(function(){
    $('.hamburger__upper .parent-txt').on('click', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('js-active');
    });
});

$(function(){
    $('#news-cat01').on('click', function() {
        $('#news-cat02').removeClass('js-active');
        $('#news-cat03').removeClass('js-active');
        $(this).addClass('js-active');

        $('#news-content02').removeClass('js-active');
        $('#news-content03').removeClass('js-active');
        $('#news-content01').addClass('js-active');
    });

    $('#news-cat02').on('click', function() {
        $('#news-cat01').removeClass('js-active');
        $('#news-cat03').removeClass('js-active');
        $(this).addClass('js-active');

        $('#news-content01').removeClass('js-active');
        $('#news-content03').removeClass('js-active');
        $('#news-content02').addClass('js-active');
    });

    $('#news-cat03').on('click', function() {
        $('#news-cat02').removeClass('js-active');
        $('#news-cat01').removeClass('js-active');
        $(this).addClass('js-active');

        $('#news-content02').removeClass('js-active');
        $('#news-content01').removeClass('js-active');
        $('#news-content03').addClass('js-active');
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const v = document.querySelector(".mv__img video");

    if (v) {
        v.muted = true;
        v.play().catch(() => {
            // ユーザー操作待ち fallback（ボタン表示など）
        });
    }
});
